import React, { Component } from "react";
import { isViewOnly } from "../services/PermissionService";

/**
 * Tells a view-only admin ("Branch Staff") why the page has no Add or Edit
 * controls.
 *
 * Without this, hiding the buttons is indistinguishable from the page being
 * broken — the most likely reaction is a support ticket, not an understanding
 * that the account is read-only. Renders nothing for everyone else.
 */
class ViewOnlyBanner extends Component {
  render() {
    if (!isViewOnly()) return null;
    return (
      <div
        className="d-flex align-items-center px-3 py-2 mb-3 rounded"
        style={{
          backgroundColor: "#f3e2ce",
          border: "1px solid #e3d5c2",
          color: "#3d2817",
          fontSize: "13px",
        }}
      >
        <i className="ri-eye-line mr-2" style={{ fontSize: "16px" }}></i>
        <span>
          <strong>View-only access.</strong> You can see this data but not change
          it. Ask a branch administrator if you need edit rights.
        </span>
      </div>
    );
  }
}

export default ViewOnlyBanner;
